import React from 'react';

import { Flex, Text } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { Input, StatusBadge } from 'components';
import Info from 'containers/Show/Info';
import { ContentRoutes } from 'enums/routes';

import ChecklistData from './Data';
import EditButton from './EditButton';

export default function FormHead({ isEditing, execution, onEdit }) {
  const { getValues, register } = useFormContext();
  const checklist = getValues();
  return (
    <>
      <Flex
        align="center"
        justify="space-between">
        <Flex
          align="center"
          mt={2}>
          <Text
            hidden={isEditing}
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            variant="3xLargeBold"
            color="gray.700">
            {checklist?.name}
          </Text>
          <Input
            viewProps={{
              hidden: !isEditing,
            }}
            label="Nome do Checklist"
            defaultValue={checklist?.name}
            {...register('name', { value: checklist.name })}
          />
          {checklist.status && (
          <StatusBadge
            label={checklist.status.toLocaleUpperCase()}
            ml={5}
            h="22px"
            status={checklist.status}
          />
          )}
        </Flex>
        <EditButton
          hidden={execution}
          onClick={onEdit}
        />
      </Flex>
      {isEditing
        ? <ChecklistData my={10} /> : (
          <Info
            fallbackContent={ContentRoutes.Checklists.concat(execution ? '-execution' : '')}
            data={{ ...checklist, ...(execution || {}) }}
          />
        )}
    </>
  );
}
